import IpdcTransparentLogo from "./ipdc_logo-transparent.png";
import ParkImage from "./park_img.jpg";
export { IpdcTransparentLogo, ParkImage };
